import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { CompanyContextService } from '../services/company-context.service';
import { CompanyFlagsService } from '../services/company-flags.service';

/**
 * Yalnızca e-fatura destekleyen (TR) şirketler için erişilebilir sayfaları korur
 * (örn. Gelen Faturalar). Bayrak çözülemezse mevcut davranışı korumak için erişime izin verir.
 */
export const eInvoicingGuard: CanActivateFn = () => {
  const companyContext = inject(CompanyContextService);
  const companyFlags = inject(CompanyFlagsService);
  const router = inject(Router);

  const known = companyContext.supportsEInvoicing();
  if (known !== null) {
    return known ? true : router.createUrlTree(['/dashboard']);
  }

  const companyId = companyContext.getSelectedCompanyId();
  if (!companyId) return true;

  return companyFlags.resolveAndStore(companyId).pipe(
    map((flags) => (flags.supportsEInvoicing === false ? router.createUrlTree(['/dashboard']) : true)),
    catchError(() => of(true)),
  );
};
